import { render, staticRenderFns } from "./DeprecationModal.vue?vue&type=template&id=73d7ff76&"
import script from "./DeprecationModal.vue?vue&type=script&lang=js&"
export * from "./DeprecationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports